import { useController } from "react-hook-form";
import { FieldError } from "../FieldError";
import { Label } from "../../../../components/ui/label";
import { Input } from "../../../../components/ui/input";
import { useEffect } from "react";
import { getPeriodLabels } from "../../utils/periodLabels";

function CurrencyInput({ name, label, control }) {
  const {
    field: { onChange, value = "", ref },
  } = useController({ name, control });

  const formatCurrency = (val) => {
    if (val === "" || val === null || val === undefined || isNaN(val)) return "";
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(Number(val));
    return formatted.replace("$", "$ ");
  };

  const parseCurrency = (val) => {
    if (!val) return null;
    const num = String(val).replace(/[^\d]/g, "");
    return num === "" ? null : Number(num);
  };

  const handleChange = (e) => {
    const raw = parseCurrency(e.target.value);
    onChange(raw);
  };

  return (
    <div className="space-y-1">
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        ref={ref}
        value={formatCurrency(value)}
        onChange={handleChange}
        placeholder={`Enter ${label}...`}
        inputMode="numeric"
      />
      <FieldError name={name} control={control} />
    </div>
  );
}

export function Revenue({ control, carriers, setValue }) {
  const labels = getPeriodLabels();

  const fields = [
    { name: "step2.revenue.projected", label: labels.projected },
    { name: "step2.revenue.current", label: labels.current },
    { name: "step2.revenue.firstPrior", label: labels.firstPrior },
    { name: "step2.revenue.secondPrior", label: labels.secondPrior },
  ];

  useEffect(() => {
    if (!carriers?.includes("Accelerant")) {
      setValue("step2.revenue", undefined, { shouldDirty: true, shouldValidate: true });
    }
  }, [carriers]);

  return (
    <>
      {carriers?.includes("Accelerant") && (
        <div className="space-y-4">
          <div className="text-lg font-semibold">Revenue</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {fields.map((f) => (
              <CurrencyInput key={f.name} {...f} control={control} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
